import { handleHover, handleKeyEvent, handleMouseEvent } from "./ui/handlers";
import { RDisplay } from "./ui/RotDisplay";
import { getScene, setScene } from "./ui/scene";
import { getTileOptions, VH, VW } from "./tiles";
import { Main } from "./core/scenes/main";

startGame();

let rotDisplay: RDisplay;

async function startGame() {
  const tileOptions = await getTileOptions();
  rotDisplay = new RDisplay({
    width: VW,
    height: VH,
    ...tileOptions,
  });

  setScene(new Main());
  //setScene(new MapGenScene());

  window.onmousedown = (event: MouseEvent | TouchEvent) => {
    handleMouseEvent(getScene().ui, "press", rotDisplay.eventToPosition(event));
  };

  window.onmouseup = (event: MouseEvent | TouchEvent) => {
    handleMouseEvent(
      getScene().ui,
      "release",
      rotDisplay.eventToPosition(event)
    );
  };

  window.onmousemove = (event: MouseEvent | TouchEvent) => {
    handleHover(getScene().ui, rotDisplay.eventToPosition(event));
  };

  window.onkeydown = (event: KeyboardEvent) => {
    handleKeyEvent(getScene().ui, "keypress", event.key, event.shiftKey);
    event.stopPropagation();
    event.preventDefault();
  };

  const container = rotDisplay.getContainer();
  if (container) {
    document.getElementById("app")?.append(container);
    requestAnimationFrame(renderUI);
  }
}

const MS_PER_FRAME = 1000 / 30;
let last = 0;
let accumulated = MS_PER_FRAME;
function renderUI(timestamp: number) {
  try {
    if (!document.hidden) {
      const scene = getScene();
      accumulated += timestamp - (last || timestamp);
      last = timestamp;
      if (accumulated >= MS_PER_FRAME) {
        while (accumulated >= MS_PER_FRAME) {
          accumulated -= MS_PER_FRAME;
          scene.update(rotDisplay, MS_PER_FRAME);
        }
        rotDisplay.clear();
        scene.render(rotDisplay);
      }
    }
  } catch (e) {
    console.error(e);
  }
  requestAnimationFrame(renderUI);
}
